import { useMemo } from "react";
import { ignoredColumns, renamedColumns, sortChildren } from "../constants";

const useSortOptions = ({ type, columns: propColumns }) => {
  return useMemo(() => {
    const _sortOptions = [];
    const _columnNames = {};
    const _columns = propColumns.filter(column => ignoredColumns[type]?.indexOf(column.dataIndex) === -1);

    for (const column of _columns) {
      let { dataIndex: value } = column;
      if (Array.isArray(value)) {
        value = value.join(".");
      }

      if (renamedColumns[value] !== undefined) {
        value = renamedColumns[value];
      }

      _sortOptions.push({
        value,
        label: column.title,
        children: sortChildren,
      });

      _columnNames[value] = column.title;
    }

    return {
      sortOptions: _sortOptions,
      columnNames: _columnNames,
    };
  }, [type, propColumns]);
};

export default useSortOptions;
